import {LoadBalanceForm} from '../../../fields/loadBalance/types'

export const buildLoadBalanceForm = (): LoadBalanceForm => {
  return {
    maxLoadSize: undefined
  }
}
